<template>
  <v-card class="amount">
    <v-form v-if="!this.$store.getters.getQrCodeScanner">
      <v-layout
        column
        align-center
        justify-center
        class="card"
      >
        <v-layout
          column
          align-center
          justify-center
          class="qrscreen"
        >
        <v-flex
          shrink
          pa-1
        >
          <v-card
            color="primary"
            class="titleqr"
          >
            <v-card-text style="color: white">{{$translate('ENTER_AMOUNT')}}</v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="flex1" xs12 sm6 md3>
          <v-text-field
            min="0"
            class="field"
            outline
            prepend-inner-icon="€"
            required
            type="number"
            v-model="currencyAmount"
          >
          </v-text-field>
        </v-flex>
        <v-flex
          shrink
          pa-1
        >
          <v-btn
            style="color: white"
            color="primary"
            round
            class="nextbtn"
            @click="goToQrScanner"
          >
            {{$translate('NEXT')}}
          </v-btn>
        </v-flex>
        <v-flex>
          <v-alert
            v-if="error1"
            value="true"
            type="error"
            class="erroralert"
          >
            {{$translate('ERROR1')}}
          </v-alert>
        </v-flex>
        </v-layout>
      </v-layout>
    </v-form>
    <v-layout
      v-if="this.$store.getters.getQrCodeScanner"
      align-center
      justify-center
      column
      fill-height
      class="qrscreen2"
      >
        <v-flex
          shrink
          pa-1
        >
          <v-card
            color="primary"
            class="camera2"
          >
            <v-card-text class="text2">{{$translate('SCAN_CODE')}}</v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs7>
          <p class="error">{{ error }}</p>
          <v-layout class="camera">
            <qrcode-stream @decode="onDecode" @init="onInit" />
            <v-btn
              style="color: white"
              color="primary"
              round
              class="cancelbtn"
              @click="cancelQrScanner"
            >
              {{$translate('CANCEL')}}
            </v-btn>
          </v-layout>
         </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog
        v-model="responseDialog"
        hide-overlay
        persistent
        width="1000"
      >
        <v-card
          color="primary"
          dark
        >
          <v-layout align-center justify-center row reverse fill-height>
            <v-flex v-if="scannedQrCode.Status == true">
              <v-card-title style="font-size: 3em">GELUKT!</v-card-title>
              <v-card-text style="font-size: 2em">Aantal toegevoegde stamps: {{scannedQrCode.StampsAdded}}</v-card-text>
              <v-card-text style="font-size: 2em">Nieuwe  saldo van klant bedraagt: {{scannedQrCode.TotalStamps}}</v-card-text>
            </v-flex>
            <v-flex v-else>
              <v-card-title style="font-size: 3em;">NIET GELUKT</v-card-title>
              <v-card-text style="font-size: 2em">Probeer het aub. nogmaals</v-card-text>
            </v-flex>
            <v-icon
              color="green"
              v-if="scannedQrCode.Status == true"
              size="500"
            >
              check
            </v-icon>
            <v-icon
              color="red"
              v-if="scannedQrCode.Status == false"
              size="500"
            >
              close
            </v-icon>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-card>


</template>

<script>
  import { QrcodeStream } from 'vue-qrcode-reader';
  import * as dssRequest from "../api/dssRequest";

  export default {

    name: "QrScanner",
    components: { QrcodeStream },

    data () {
      return {
        responseDialog: false,
        result: '',
        error: '',
        error1: false,
        amountEuros: '',
        scannedQrCode: {},
        currencyAmount: "",
      }
    },
    watch: {
      result: function(newV, oldV) {
        if (newV !== oldV && newV !== '') {
          this.addDutchStamps(newV);
        }
      },
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.$store.commit("setStampsDialog", true)), 5000)
      }
    },
    methods: {
      onDecode (result) {

        this.result = result
      },
      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permission"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },
      goToQrScanner () {
        if (this.currencyAmount == "") {
          this.$store.getters.getQrCodeScanner == false;
          this.error1 = true;
        }
        if (!_.isEmpty(this.currencyAmount)){
          this.error1 = false;
          this.$store.commit("setQrCodeScanner", true);
        }
      },
      cancelQrScanner () {
        if (this.$store.getters.getQrCodeScanner == true) {
          this.$store.commit("setQrCodeScanner", false);
          this.currencyAmount = "";
        }
      },
      // getMyOrder(item) {
      //   if (!item) {
      //     // if there is no orderId available, return
      //     return;
      //   }
      //   if(!_.isEmpty(this.$store.getters["auth/userName"])){
      //     const payload = {
      //       OrderId: item
      //     };
      //     dssRequest.doRequest(
      //       response => {
      //         console.log(
      //           "The generic call getMyOrder was successful",
      //           response
      //         );
      //         this.scannedOrder = response.data;
      //       },
      //       error => {
      //         console.log(
      //           "The generic call getMyOrder was not successful",
      //           error
      //         );
      //       },
      //       "getMyOrder",
      //       this.$store.getters["auth/userName"],
      //       payload
      //     );
      //   }
      // },
      addDutchStamps(userId, currencyAmount) {
        // Adding the stamps to the user by scanning the QR code
        this.scannedQrCode = {};
        if (!userId) {
          // if there is no orderId available, return
          return;
        }

        const objectId = "";
        if (this.$store.getters['auth/partnerId'] !== -1) {
          this.objectId = this.$store.getters.getCurrentAccountId + "_UG_" + this.$store.getters['auth/partnerId'];
        } else {
          this.objectId = userId;
        }

        if(!_.isEmpty(this.$store.getters["auth/userName"])){
          const payload = {
            UserId: userId,
            CurrencyAmount: this.currencyAmount
          };
          dssRequest.doRequest(
            response => {
              console.log(
                "The generic call addDutchStamps was successful",
                response
              );
              this.responseDialog = true;
              this.scannedQrCode.Status = true;
              this.scannedQrCode.StampsAdded = response.data.StampsAdded;
              this.scannedQrCode.TotalStamps = response.data.TotalStamps;
              setTimeout(() => {
                this.responseDialog = false;
                this.result = '';
              }, 5000);
            },
            error => {
              console.log(
                "The generic call addDutchStamps was not successful",
                error
              );
              this.responseDialog = true;
              this.scannedQrCode.Status = false;

              setTimeout(() => {
                  this.responseDialog = false;
                  this.result = '';
              }, 5000)
            },
            "addDutchStamps",
            this.objectId,
            payload,
            600000,
            false
          );
        }
        this.$store.commit("setQrCodeScanner", false);
        this.currencyAmount = null;
      }
    }
  }
</script>

<style scoped lang="scss">
  /*.error {*/
  /*  font-weight: bold;*/
  /*  color: red;*/
  /*}*/
  /*.amount {*/
  /*  height: 80vh;*/
  /*}*/
  /*.amount2 {*/
  /*  font-size: 5em;*/
  /*  margin-bottom: 1em;*/
  /*}*/
  /*.field {*/
  /*  transform: scale(4);*/
  /*  font-size: 1.5em;*/
  /*}*/
  /*.flex1 {*/
  /*  padding-top: 6em;*/
  /*  padding-bottom: 5em;*/
  /*}*/
  /*.nextbtn {*/
  /*  font-size: 5em;*/
  /*  height: auto;*/
  /*}*/
  /*.cancelbtn {*/
  /*  font-size: 2em;*/
  /*  height: auto;*/
  /*  margin-left: -16em;*/
  /*  margin-top: 1.5em;*/
  /*}*/
  /*.camera {*/
  /*  height: 50vh;*/
  /*  width: 50vh;*/
  /*  margin-left: -3.3em;*/
  /*  margin-top: -1.5em;*/
  /*}*/
  /*.camera2 {*/
  /*  font-size: 5em;*/
  /*}*/
  /*.erroralert {*/
  /*  color: white;*/
  /*}*/
  /*.data {*/
  /*  margin-top: -26em;*/
  /*  margin-left: 30em;*/
  /*  width: 25em;*/
  /*}*/
  .titleqr {
    font-size: 3em;
    margin: 1em;
    text-align: center;
  }
  .field {
    transform: scale(1.5);
  }
  .nextbtn {
    font-size: 3em;
    height: auto;
  }
  .text2 {
    font-size: 3em;
    text-align: center;
    color: white;
  }
  .amount {
    padding-bottom: 25.5em;
  }
  .qrscreen {
    padding: 10em 10em 0 10em;
  }
  .qrscreen2 {
    padding: 10em 10em 0 10em;
  }
</style>
